<style lang="scss" scoped>
.search-container {
  width: auto;
}

.search-container > button,
.search-container > div {
  margin-left: 8px;
  &:nth-child(1) {
    margin-left: 0;
  }
  // .el-input {
  //   border-color: red;
  // }
}
</style>

<template>
  <div class="search-container clearfix">
    <el-input v-model="value"
      @keyup.enter.native="clickSearchHandler"
      :placeholder="placeholder" size="medium" style="width: 200px;"
      class="az-line-block "></el-input>
    <el-button type="success" size="medium" @click="clickSearchHandler"
      class="az-line-block ">搜索</el-button>
  </div>
</template>
<script>
/**
 * @flow
 * 搜索组件
 * @support
 * 1.首次进入初始化input框的值；
 * 2.点查找时，将input框的值通知到外部组件；
 * @export 
 * 1.hasSelector为True时，导出{'keyword':'value'}，如{phone:13261688305}；
 * 2.hasSelector为false时，直接导出value；
 * @用法
 * 有两种用法，
 * 一种是没有筛选类型，直接通过@search事件，将值通知给外部组件。
 * 另一种是，props的hasSelector设置为True且selectorOptions存在，这时候返回的是{user:徐志响}这样的对象值；
 */
export default {
  name: 'azSearch',
  data() {
    return {
      keyword: '',
      value: ''
    }
  },
  props: {
    hasSelector: {
      type: Boolean,
      default: false
    },
    /**
     * 搜索类型列表，格式如：[{keyword:'user', label:'用户名'}, {keyword:'phone', label:'手机号'}]
     */
    selectorOptions: {
      type: Array,
      default: function () {
        return [];
      }
    },
    placeholder: {
      type: String,
      default: '请输入您要检索的内容'
    },
    initValue: {
      type: String,
      default: ''
    },
    initKeyword: {
      type: String,
      default: ''
    }
  },
  methods: {
    clickSearchHandler() {
      this.$emit(
        'search',
        this.hasSelector && this.selectorOptions.length > 0 ? { [this.keyword]: this.value } : this.value
      );
    },
    initPage() {
      (this.hasSelector ? initSelectorValue : initOnlyValue)(this)
    },

  },
  mounted() {
    this.$on('clear', () => {
      console.log('111111111111111')
      this.value = ''
    })
  },
  created() {
    this.initPage();
  }
};

/**
 * init value of data;
 */
function initSelectorValue(_this: vue) {
  _this.value = _this.initValue;
  _this.keyword = _this.initKeyword || (_this.selectorOptions[0] ? _this.selectorOptions[0].keyword : '');
}

/**
 * init keyword of data
 */
function initOnlyValue(_this: vue) {
  _this.value = _this.initValue;
}
</script>